import 'dayjs/locale/zh-tw'

const zh_tw = {
  calendar: {
    sameDay: '[今天] LT',
    nextDay: '[明天] LT',
    nextWeek: '[下]dddd LT',
    lastDay: '[昨天] LT',
    lastWeek: '[上]dddd LT',
    sameElse: 'L'
  }
}

export default zh_tw
